@for (performance of performancesWithWeekInfo; track trackByPerformanceId($index, performance)) {
  <!-- Week divider -->
  @if (performance.showWeekDivider) {
    <div class="week-divider">
      Week {{ performance.weekNumber }}
    </div>
  }
  <!-- Day group container -->
  <div class="day-group"
    [class.day-group-start]="performance.showDayDivider"
    [class.day-group-end]="performance.isLastOfDay"
    [class.day-group-single]="performance.showDayDivider && performance.isLastOfDay">
    <!-- Day indicator for first performance when multiple on same day -->
    @if (performance.showDayDivider && !performance.isLastOfDay) {
      <div class="day-indicator"></div>
    }
    <app-planner-performance-row
      (toneelmeesterScheduleRequested)="emitClick(performance, $event)"
      [allowEdit]="allowEdit"
      [attr.id]="'performance-' + performance.id"
      [availabilities]="availabilities"
      [performance]="performance"
      [toneelmeesters]="toneelmeesters"
      />
    </div>
  }
